

<!-- HERO -->
<section class="tsr-hero">
  <div class="tsr-hero-grid-lines"></div>
  <div class="tsr-hero-inner">
    <div>
      <span class="tsr-eyebrow"><i class="ti ti-trophy"></i> Parent Power League Table 2026</span>
      <h1>Top 100 Independent Schools <span>in the UK</span></h1>
      <p class="tsr-sub">Ranked by 2025 A-Level and GCSE outcomes. Explore how the country's leading schools performed, and find the entry-test resources to help your child get there.</p>
      <div class="tsr-hero-stats">
        <div class="tsr-hero-stat" *ngFor="let stat of tsrHeroStats">
          <b>{{ stat.current }}{{ stat.suffix }}</b>
          <span>{{ stat.label }}</span>
        </div>
      </div>
    </div>

    <div class="tsr-podium">
      <div class="tsr-pod-col tsr-pod-2">
        <div class="tsr-pod-crest">#2</div>
        <div class="tsr-pod-name">Brighton College</div>
        <div class="tsr-pod-bar">97.9%</div>
      </div>
      <div class="tsr-pod-col tsr-pod-1">
        <div class="tsr-pod-crest"><i class="ti ti-crown"></i></div>
        <div class="tsr-pod-name">St Paul's School</div>
        <div class="tsr-pod-bar">98.2%</div>
      </div>
      <div class="tsr-pod-col tsr-pod-3">
        <div class="tsr-pod-crest">#3</div>
        <div class="tsr-pod-name">North London Collegiate</div>
        <div class="tsr-pod-bar">96.6%</div>
      </div>
    </div>
  </div>

  <div class="tsr-marquee-wrap">
    <div class="tsr-marquee-track">
      <ng-container *ngFor="let loop of [0,1]">
        <div class="tsr-marquee-item" *ngFor="let s of tsrMarqueeItems">
          <b>#{{ s.rank }}</b> {{ s.name }}
        </div>
      </ng-container>
    </div>
  </div>
</section>

<!-- TOP 10 SPOTLIGHT -->
<section class="tsr-section">
  <div class="tsr-section-head">
    <div>
      <span class="tsr-eyebrow-sm">The Ranking</span>
      <h2>The Top 10, In Focus</h2>
      <p class="tsr-section-desc">Full year-on-year movement and academic context for the highest-ranked schools nationally.</p>
    </div>
  </div>

  <div class="tsr-top10-grid">
    <div class="tsr-card" [ngClass]="'tsr-rank-' + s.rank" *ngFor="let s of tsrTop10">
      <span class="tsr-card-ghost">{{ s.rank }}</span>
      <div class="tsr-card-body">
        <div class="tsr-card-top">
          <div class="tsr-rank-badge">#{{ s.rank }}</div>
          <span class="tsr-change" [ngClass]="s.change">
            <i class="ti" [ngClass]="tsrChangeIcon[s.change]"></i> {{ s.changeText }}
          </span>
        </div>
        <h3>{{ s.name }}</h3>
        <p class="tsr-loc"><i class="ti ti-map-pin"></i> {{ s.loc }}</p>

        <div class="tsr-compare">
          <div class="tsr-compare-item">
            <div class="tsr-compare-top">
              <span class="tsr-compare-name">A-Level A*&ndash;B</span>
              <span class="tsr-compare-value">{{ s.alevel }}%</span>
            </div>
            <div class="tsr-compare-track">
              <div class="tsr-compare-fill tsr-alevel" [attr.data-width]="s.alevel"></div>
            </div>
          </div>
          <div class="tsr-compare-item">
            <div class="tsr-compare-top">
              <span class="tsr-compare-name">GCSE 9-7</span>
              <span class="tsr-compare-value">{{ s.gcse }}%</span>
            </div>
            <div class="tsr-compare-track">
              <div class="tsr-compare-fill tsr-gcse" [attr.data-width]="s.gcse"></div>
            </div>
          </div>
        </div>

        <p class="tsr-desc">{{ s.desc }}</p>

        <div class="tsr-card-foot">
          <span class="tsr-gender-tag">
            <i class="ti" [ngClass]="tsrGenderIcon[s.gender]"></i> {{ tsrGenderLabel(s.gender) }} entry
          </span>
          <a href="javascript:void(0)" class="tsr-cta-link">{{ s.guide }} <i class="ti ti-arrow-right"></i></a>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- FULL RANKING TABLE -->
<section class="tsr-section tsr-no-top-pad">
  <div class="tsr-section-head">
    <div>
      <span class="tsr-eyebrow-sm">Full League Table</span>
      <h2>Ranks 1&ndash;100</h2>
      <p class="tsr-section-desc">Search by school or town, and filter by entry gender to build your shortlist.</p>
    </div>
  </div>

  <div class="tsr-filterbar">
    <div class="tsr-search">
      <i class="ti ti-search"></i>
      <input
        type="text"
        placeholder="Search school name or location..."
        [ngModel]="tsrSearch"
        (ngModelChange)="tsrOnSearchChange($event)">
    </div>
    <div class="tsr-filter-chips">
      <div class="tsr-fchip" [class.tsr-active]="tsrGender === 'all'" (click)="tsrSetGender('all')">All Schools</div>
      <div class="tsr-fchip" [class.tsr-active]="tsrGender === 'girls'" (click)="tsrSetGender('girls')">Girls</div>
      <div class="tsr-fchip" [class.tsr-active]="tsrGender === 'boys'" (click)="tsrSetGender('boys')">Boys</div>
      <div class="tsr-fchip" [class.tsr-active]="tsrGender === 'mixed'" (click)="tsrSetGender('mixed')">Mixed</div>
    </div>
  </div>

  <div class="tsr-table-wrap">
    <!-- horizontal scroll wrapper fixes mobile clipping: table keeps a min-width and
         scrolls sideways instead of squeezing/cutting off columns -->
    <div class="tsr-table-scroll">
      <table class="tsr-table">
        <thead>
          <tr>
            <th (click)="tsrSort('rank')">Rank <i class="ti ti-arrows-sort"></i></th>
            <th (click)="tsrSort('name')">School <i class="ti ti-arrows-sort"></i></th>
            <th (click)="tsrSort('alevel')">A-Level A*&ndash;B <i class="ti ti-arrows-sort"></i></th>
            <th (click)="tsrSort('gcse')">GCSE 9-7 <i class="ti ti-arrows-sort"></i></th>
            <th (click)="tsrSort('gender')">Entry <i class="ti ti-arrows-sort"></i></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngIf="tsrPageRows.length === 0" class="tsr-empty-row">
            <td colspan="5"><i class="ti ti-mood-empty"></i> No schools match your search.</td>
          </tr>
          <tr *ngFor="let r of tsrPageRows">
            <td class="tsr-td-rank">{{ r.rank }}</td>
            <td class="tsr-td-school">
              {{ r.name }}
              <small><i class="ti ti-map-pin"></i> {{ r.loc }}</small>
            </td>
            <td class="tsr-td-alevel">{{ r.alevel }}%</td>
            <td class="tsr-td-gcse">{{ r.gcse }}%</td>
            <td>
              <span class="tsr-badge-gender">
                <i class="ti" [ngClass]="tsrGenderIcon[r.gender]"></i> {{ tsrGenderLabel(r.gender) }}
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- mobile scroll hint -->
    <div class="tsr-scroll-hint">
      <i class="ti ti-arrow-left-right"></i> Swipe to see all columns
    </div>

    <div class="tsr-table-foot">
      <span>Showing {{ tsrPageRows.length }} of {{ tsrFilteredRows.length }} school{{ tsrFilteredRows.length !== 1 ? 's' : '' }}</span>
      <div class="tsr-pagebtns">
        <button class="tsr-pagebtn" [disabled]="tsrPage === 1" (click)="tsrGoPage(tsrPage - 1)">
          <i class="ti ti-chevron-left"></i>
        </button>
        <ng-container *ngFor="let p of tsrPageNumbers">
          <span class="tsr-pagebtn tsr-ellipsis" *ngIf="p === 0">&hellip;</span>
          <button class="tsr-pagebtn" [class.tsr-active]="p === tsrPage" *ngIf="p !== 0" (click)="tsrGoPage(p)">{{ p }}</button>
        </ng-container>
        <button class="tsr-pagebtn" [disabled]="tsrPage === tsrTotalPages" (click)="tsrGoPage(tsrPage + 1)">
          <i class="ti ti-chevron-right"></i>
        </button>
      </div>
    </div>
  </div>
</section>

<!-- CTA -->
<div class="tsr-cta-strip">
  <div>
    <h3>Aiming for a Top 100 school?</h3>
    <p>Take Sehyog Academy's free assessment to benchmark your child against the entry standards these schools expect.</p>
  </div>
  <a href="javascript:void(0)" class="tsr-cta-btn"><i class="ti ti-arrow-right"></i> Start Free Assessment</a>
</div>
